import { AppController } from 'app/controllers';
import { computed, makeObservable } from 'mobx';
import { UserRoles } from 'src/types/user';

export class UserRoleViewModel {
    constructor() {
        makeObservable(this, {
            role: computed,
        });
    }

    get role(): UserRoles {
        const permissions = AppController.Instance.Users?.user?.permissions;

        if (
            permissions?.canListAllCampaigns &&
            permissions?.canListAllProducts &&
            permissions?.canListAllUsers &&
            permissions?.canListAllPurchases &&
            permissions?.canEditAllCampaigns &&
            permissions?.canSetPremiumLevel
        ) {
            return UserRoles.Admin;
        }

        return UserRoles.Default;
    }

    public get isDefaultUser() { return this.role === UserRoles.Default; }
    public get isAdmin() { return this.role === UserRoles.Admin; }
}
